import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
import { IProduktionsmallProduktPrimaryKey } from "./ProduktionsmallProduktBaseCommand";

export abstract class ProduktionsmallProduktinstruktionBaseCommand extends BasicCommand<ProduktionsmallProduktinstruktionBaseCommand> {
    produktionsmallGuid: string;
    handelssortimentId: number;
    produktId: number;
    produktinstruktionId: number;
    medIUtbytessimulering: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "ProduktionsmallProduktinstruktion";

    get primaryKey(): IPrimaryKey<IProduktionsmallProduktinstruktionPrimaryKey> {
        return {
            produktionsmallGuid: this.produktionsmallGuid,
            handelssortimentId: this.handelssortimentId,
            produktId: this.produktId,
            produktinstruktionId: this.produktinstruktionId
        };
    }

    constructor($type: string, commandType: CommandType) {
        super($type, ProduktionsmallProduktinstruktionBaseCommand.$groupKey, commandType);
    }
}

export interface IProduktionsmallProduktinstruktionPrimaryKey extends IProduktionsmallProduktPrimaryKey {
    produktinstruktionId: number;
}
